<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="盘盈盘亏" v-if="findChildren(132)!==-1" name="inventoryquantityadjust" style="height: 100%;">
				<inventoryquantityadjust-index />
			</el-tab-pane>		
			<el-tab-pane label="成本调价" v-if="findChildren(134)!==-1" name="inventorycostadjust" style="height: 100%;">
				<inventorycostadjust-index />
			</el-tab-pane>	
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import inventoryquantityadjustIndex from './inventoryquantityadjust/index.vue'
	import inventorycostadjustIndex from './inventorycostadjust/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			inventoryquantityadjustIndex,
			inventorycostadjustIndex
		}
	}
</script>